import { render, staticRenderFns } from "./ElectivePoolsTable.vue?vue&type=template&id=0f0a4438&"
import script from "./ElectivePoolsTable.vue?vue&type=script&lang=js&"
export * from "./ElectivePoolsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports